module.exports = __webpack_public_path__ + "img/expire.4eb9dc4d.png";